import React, { useReducer,useState, useEffect } from 'react'
import { connect } from "react-redux";
import { formValues, setTabHideValues } from "../../redux/actions/action";
import { OnChange } from "react-final-form-listeners";
import axios from 'axios';
import { useGlobalSpinnerActionsContext } from '../../context/GlobalSpinnerContext'
import _ from 'lodash';
import OUMapping from '../../assets/data/registerOU'
import { facilityMapping } from '../../assets/data/facilityOU'
import { DropzoneArea } from 'material-ui-dropzone'
import { DropzoneDialog } from 'material-ui-dropzone'
import { useHistory } from "react-router-dom";

import HideShowCondition from "../validation/HideShowCondition";

import AssignCondition from "../validation/Assign";

import Validator from '../validation/validator/validatorStage'
import { HideCheckboxOptions } from '../../assets/data/hideCheckboxOnCondition'
import ShowError from "../validation/showError/ShowError";

// import HideStageFieldsOptions from '../validation/hideOptions/HideStageFieldsOptions'
import OUFieldConfig from './OUStageFieldConfig';
import DisplayText from "../validation/DisplayText.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQrcode, faTimes, faFileUpload } from "@fortawesome/free-solid-svg-icons";
import QrReader from 'react-qr-reader'
import Html5QrcodePlugin from '../html5qrbarcodescanner/Html5QrBarcodeScanner';
import ReferalForm from "../forms/referalForm/ReferalForm";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { isEmpty, isString } from "../../helper/index";
import {
    Button,
    ButtonStrip,
    InputFieldFF,
    SingleSelectFieldFF,
    ReactFinalForm,
    SwitchFieldFF,
    hasValue,
    TextAreaFieldFF,
    composeValidators,
    dhis2Username,
    FieldGroupFF,
    CheckboxFieldFF,
    RadioFieldFF,
    MultiSelectFieldFF,
    FileInput,
    FileInputFieldFF,
    CheckboxField
} from "@dhis2/ui";

import {
    TextField,
    Checkboxes,
    CheckboxData,
    Radios,
    Select,
    TimePicker,
    Switches,
    KeyboardDatePicker,
    DatePicker,
    DateTimePicker,
    Autocomplete,
} from "mui-rff";
//import { CheckboxField } from '@dhis2-ui/checkbox'

//   import { Select } from 'mui-rff';
import { MenuItem } from "@material-ui/core";

import Grid from "@material-ui/core/Grid";

import { Checkbox as MuiCheckbox } from "@material-ui/core";

//   import {Checkboxes, CheckboxData} from 'mui-rff';

import "date-fns";
import DateFnsUtils from "@date-io/date-fns";

import { apiServices } from "../../services/apiServices";
import { useTranslation } from 'react-i18next';
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from '@material-ui/core/FormLabel';
import moment from "moment";
import { APP_LOCALE } from '../../../src/assets/data/config.js'; 
import { getDateFormat,checkCalcBMI,getDataElementIdForBMIFlag,getKeyByValue,getAttributeValue,dynamiccalculateBMI,checkFieldCondition_dhis_} from '../../config/validationutils';


const { Form, Field } = ReactFinalForm;

const ValidatorComponent = (
    fieldId,
    attribute,
    values,
    form,
    rules,
    field,
) => {
    let programRules = rules.programRule;
    let programRulesVariables = rules.programRuleVariable;

    let filteringRuleWithField = null;
    let Flag = null;
    let val = null;
    let conditionArray = [];
    let programRuleActionType = null;
    let hideShow = true
    let assign
    programRules.map((rules) => {
        filteringRuleWithField = rules.programRuleActions.filter((obj) =>
            obj.dataElement ? fieldId == obj.dataElement.id : undefined
        );

        if (filteringRuleWithField.length > 0) {
            switch (filteringRuleWithField[0].programRuleActionType) {
                case "HIDEFIELD":
                    hideShow = HideShowCondition(
                        rules,
                        programRulesVariables,
                        values,
                        field,
                        fieldId
                    );
                    break;

                case "ASSIGN":
                    assign =
                        AssignCondition(
                            rules,
                            programRulesVariables,
                            values,
                            field,
                            fieldId,
                            attribute,
                            filteringRuleWithField

                        );
                    break;

                // case 'DISPLAYTEXT':
                //
                //     programRuleActionType = DisplayText(rules, programRulesVariables, values, field, fieldId)
                // break;

                // case "SHOWERROR":
                //   programRuleActionType = ShowError(
                //     rules,
                //     programRulesVariables,
                //     values,
                //     field,
                //     fieldId,
                //     attribute
                //   );
                //   break;

                // case 'HIDEOPTION':
                //     programRuleActionType = HideStageFieldsOptions(rules, programRulesVariables, values, field, fieldId, attribute)
                // break;
            }
        }
    });
    return ({
        'hideShow': hideShow,
        'assign': assign
    })
};
const getTranslatedLabels = (dataElement) => {
    if (localStorage.getItem("locale") == "en") {
        return dataElement.formName ? dataElement.formName : dataElement.displayName ? dataElement.displayName : dataElement.description;
    } else if (dataElement.translations && dataElement.translations.length > 0) {
        let label = dataElement.translations.filter(
            (tanslation) =>
                tanslation.property == "NAME" &&
                tanslation.locale == localStorage.getItem("locale")
        );
        if (label.length > 0) {
            return label[0].value;
        } else {
            return dataElement.formName ? dataElement.formName : dataElement.displayName ? dataElement.displayName : dataElement.description;
        }
    }
    return dataElement.formName ? dataElement.formName : dataElement.displayName ? dataElement.displayName : dataElement.description;
};

function InputFieldConfig(props) {
    const { t } = useTranslation()
    const history = useHistory();
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let dataElementGroup = props.dataElementGroup
    let customfieldobj = props.customfieldobj
    let customClassName = props.customClassName
    let symptomsFID = props.symptomsFID
    let Configuration = props.Configuration
    const [fieldType, setFieldType] = useState(null)
    const [optionSet, setOptions] = useState(null)
    const [icons, setIcons] = useState(null)
    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)
    let OUJSON = props.OUJSON.organisationUnits
    let orgid = props.programorgid
    const required = value => (fieldData.compulsory && validationResult.hideShow == true ? value ? undefined : t('Required') : undefined)
    // const scriptCheck = value => (value ? value.match(/<[^>]*>/g) != null ? t('Incorrect expression "< or >" added as input') : undefined : undefined)
    const scriptCheck = value => {
        if (value && typeof value === 'string') {
            return value.match(/<[^>]*>/g) !== null ? t('Incorrect expression "< or >" added as input') : undefined;
        }
        return undefined;
    };

    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    const checkboxDependent = [
        //uat
        {
            dependentField: [customfieldobj.testingforTBinfectionID],
            option: customfieldobj.noneOptionID,
        }
    ]
    function checkHideOptionsFields(attributes, programRules, programRulesVariables, values) {
        const fieldId = attributes.dataElement.id;
        let option = [];
        let filteringRuleWithField = null;

        programRules.map((rules) => {
            filteringRuleWithField = rules.programRuleActions.filter((obj) =>
                obj.dataElement ? fieldId == obj.dataElement.id : undefined
            );

            if (
                filteringRuleWithField.length > 0 &&
                filteringRuleWithField[0].programRuleActionType == "HIDEOPTION"
            ) {
                const operators = ["==", "!="];
                const condition = rules.condition;
                const splitConditions = condition.split("&&");
                let Flag = null;
                let val = null;
                let conditionArray = [];
                splitConditions.map((splitCondition) => {
                    const variableName = splitCondition.match(/\{(.*?)\}/)[1];
                    const parentRaw = programRulesVariables.filter(
                        (obj) => obj.displayName == splitCondition.match(/\{(.*?)\}/)[1]
                    ); //[0] .dataElement.id
                    const parentNameFromFilter =
                        parentRaw.length > 0 ? parentRaw[0].displayName : undefined;
                    const parentId =
                        parentRaw.length > 0
                            ? parentRaw[0].dataElement
                                ? parentRaw[0].dataElement.id
                                : parentRaw[0].trackedEntityAttribute
                                    ? parentRaw[0].trackedEntityAttribute.id
                                    : undefined
                            : undefined;

                    const parentNameFromFilterStart = splitCondition.search(
                        parentNameFromFilter
                    );
                    const parentNameLength = parentNameFromFilter
                        ? parentNameFromFilter.length
                        : undefined;

                    const operatorInitLength =
                        parentNameFromFilterStart + parentNameLength + 2;

                    const operator = splitCondition.substring(
                        operatorInitLength,
                        operatorInitLength + 2
                    );

                    const alternateOperatorFinding = operators.map((ops) => {
                        if (splitCondition.search(ops) > -1) {
                            const a = {
                                operator: ops,
                                operatorLength: splitCondition.search(ops),
                            };
                            return a;
                        }
                    });
                    const stringLength = splitCondition.length;
                    if (parentNameFromFilter) {
                        const filteredOperator = alternateOperatorFinding.filter(
                            (obj) => obj != undefined
                        );

                        const conditionValueRaw =
                            filteredOperator.length > 0
                                ? splitCondition.substring(
                                    filteredOperator[0].operatorLength + 3,
                                    splitCondition.length
                                )
                                : undefined;

                        const removeEmptySpace =
                            conditionValueRaw != undefined
                                ? conditionValueRaw.substring(
                                    conditionValueRaw.length - 1,
                                    conditionValueRaw.length
                                ) == " "
                                    ? conditionValueRaw.substring(0, conditionValueRaw.length - 1)
                                    : conditionValueRaw
                                : undefined;

                        const conditionValue =
                            removeEmptySpace != undefined
                                ? removeEmptySpace.substring(1, removeEmptySpace.length - 1)
                                : undefined;
                        const conditionalOperator =
                            filteredOperator.length > 0
                                ? filteredOperator[0].operator
                                : undefined;
                        let conditionForValidation = null;
                        if (conditionalOperator != undefined) {
                            val = conditionValue;
                            switch (conditionalOperator) {
                                case "==":
                                    if (
                                        values[parentId] != undefined &&
                                        String(values[parentId]) == String(conditionValue)
                                    ) {
                                        // values[fieldId] = ''

                                        filteringRuleWithField.map((optionHideRule) => {
                                            attributes.dataElement.optionSet.options.map(
                                                (options) => {
                                                    if (options.id != optionHideRule.option.id) {
                                                        if (option.length > 0) {
                                                            let checkOptionInArray = option.find(obj => obj.id == options.id)
                                                            if (checkOptionInArray == undefined) {
                                                                option.push(options);
                                                            }

                                                        } else {
                                                            option.push(options);
                                                        }



                                                    } else {
                                                        // values[fieldId] = ''

                                                        var temp = {
                                                            id: options.id,
                                                            code: options.code,
                                                            displayName: null,
                                                        };

                                                        let checkOptionInArray = option.find(obj => obj.id == temp.id)

                                                        if (checkOptionInArray == undefined) {
                                                            option.push(temp);
                                                        }


                                                    }
                                                }
                                            );
                                        });
                                    } else {
                                        // values[fieldId] = ''
                                    }
                                    break;

                                case ">=":
                                    if (
                                        values[parentId] != undefined &&
                                        Number(values[parentId]) >= Number(conditionValue)
                                    ) {
                                        // values[fieldId] = ''

                                        filteringRuleWithField.map((optionHideRule) => {
                                            attributes.dataElement.optionSet.options.map(
                                                (options) => {
                                                    if (options.id != optionHideRule.option.id) {
                                                        option.push(options);
                                                    } else {
                                                        // values[fieldId] = ''

                                                        var temp = {
                                                            id: options.id,
                                                            code: options.code,
                                                            displayName: null,
                                                        };
                                                        option.push(temp);
                                                    }
                                                }
                                            );
                                        });
                                    } else {
                                        // values[fieldId] = ''
                                    }
                                    break;

                                case "<=":
                                    if (
                                        values[parentId] != undefined &&
                                        Number(values[parentId]) <= Number(conditionValue)
                                    ) {
                                        // values[fieldId] = ''

                                        filteringRuleWithField.map((optionHideRule) => {
                                            attributes.dataElement.optionSet.options.map(
                                                (options) => {
                                                    if (options.id != optionHideRule.option.id) {
                                                        option.push(options);
                                                    } else {
                                                        // values[fieldId] = ''

                                                        var temp = {
                                                            id: options.id,
                                                            code: options.code,
                                                            displayName: null,
                                                        };
                                                        option.push(temp);
                                                    }
                                                }
                                            );
                                        });
                                    } else {
                                        // values[fieldId] = ''
                                    }
                                    break;

                                case "<":
                                    if (
                                        values[parentId] != undefined &&
                                        Number(values[parentId]) < Number(conditionValue)
                                    ) {
                                        // values[fieldId] = ''

                                        filteringRuleWithField.map((optionHideRule) => {
                                            attributes.dataElement.optionSet.options.map(
                                                (options) => {
                                                    if (options.id != optionHideRule.option.id) {
                                                        option.push(options);
                                                    } else {
                                                        // values[fieldId] = ''

                                                        var temp = {
                                                            id: options.id,
                                                            code: options.code,
                                                            displayName: null,
                                                        };
                                                        option.push(temp);
                                                    }
                                                }
                                            );
                                        });
                                    } else {
                                        // values[fieldId] = ''
                                    }
                                    break;

                                case ">":
                                    if (
                                        values[parentId] != undefined &&
                                        Number(values[parentId]) > Number(conditionValue)
                                    ) {
                                        // values[fieldId] = ''

                                        filteringRuleWithField.map((optionHideRule) => {
                                            attributes.dataElement.optionSet.options.map(
                                                (options) => {
                                                    if (options.id != optionHideRule.option.id) {
                                                        option.push(options);
                                                    } else {
                                                        // values[fieldId] = ''

                                                        var temp = {
                                                            id: options.id,
                                                            code: options.code,
                                                            displayName: null,
                                                        };
                                                        option.push(temp);
                                                    }
                                                }
                                            );
                                        });
                                    } else {
                                        // values[fieldId] = ''
                                    }
                                    break;
                            }
                        } else {
                            // values[parentId] != ''
                            // values[fieldId] = ''
                        }
                    }
                });
            }
        });

        if (option.length > 0) {
            return option;
        } else {
            return attributes.dataElement.optionSet.options
        }
    }

    function findFieldType() {
        const dataElement = fieldData.dataElement
        if (dataElement.optionSet != undefined) {
            if (fieldData.renderOptionsAsRadio ||
                (fieldData.renderType && fieldData.renderType['DESKTOP'] &&
                    fieldData.renderType['DESKTOP'].type &&
                    fieldData.renderType['DESKTOP'].type == 'HORIZONTAL_RADIOBUTTONS')) {
                setFieldType('radio')
            } else {
                if (fieldData.renderType) {
                    if (fieldData.renderType.DESKTOP) {
                        if (fieldData.renderType.DESKTOP.type == "ICONS_AS_BUTTONS") {
                            setFieldType('radio')
                        } else {
                            setFieldType('dropdown')
                        }
                    }
                }
            }
        } else {
            setFieldType('text')
        }

    }

    function fetchOption() {
        let output = []
        const dataElement = fieldData.dataElement

        if (dataElement.optionSet != undefined) {
            if (dataElement.id == customfieldobj.patientStatus) {
                if (values && !values[customfieldobj.patientStatus]) {
                    fieldData.dataElement.optionSet.options.find((o) => {
                        console.log("patientStatus", o)
                        if (o.code == "On Treatment") {
                            values[customfieldobj.patientStatus] = o.code
                        }
                    });
                }
            }
            let refinedOptionList = checkHideOptionsFields(fieldData, programRules, programRulesVariables, values);

            //dataElement.optionSet.options.map((items, index) => {
            refinedOptionList.map((items, index) => {
                if (icons.length > 0) {
                    output.push({ 'value': items.code, 'label': <> <span dangerouslySetInnerHTML={{ __html: icons[index] }} /> <>{getTranslatedLabels(items)} </>  </> })
                } else {
                    output.push({ 'value': items.code, 'label': getTranslatedLabels(items) })
                }
            })

        }
        if (output.length > 0) {
            setOptions(output)
        }
    }

    function getIcons() {
        let promises = [];
        const dataElement = fieldData.dataElement
        if (navigator.onLine) {
            if (dataElement.optionSet != undefined) {
                dataElement.optionSet.options.forEach((options) => {
                    if (options.style != undefined) {

                        const getIconApi = 'icons/' + options.style.icon + '/icon.svg'
                        promises.push(apiServices.getAPI(getIconApi))
                    } else {
                        promises.push({})
                    }
                })

                Promise.all(promises).then((responses) => {

                    const icons = responses.map((response) => response.data)

                    if (icons.length > 0) {
                        setIcons(icons)
                    } else {
                        setIcons([])
                    }
                })
            } else {
                setIcons([])
            }
        } else {
            setIcons([])
        }


    }

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        getIcons()
    }, [])

    useEffect(() => {
        if (Array.isArray(icons)) {
            findFieldType()
            fetchOption()
            fetchValidation()
        }

    }, [icons, values, localStorage.getItem("locale")])

    useEffect(() => {

        if (validationResult != null && fieldType != null) {
            let customProps = { className: customClassName };


            try {
                checkboxDependent.map((o) => {
                    if (o.dependentField.includes(fieldData.dataElement.id)) { //for symptoms
                        customProps = { ...customProps, className: "hide" };
                        if (values[o.option]) {
                            if (values[customfieldobj.CXRreportavailableID] && (values[customfieldobj.CXRreportavailableID] == 'No' || (values[customfieldobj.CXRresultId] && values[customfieldobj.CXRresultId] == 'Not suggestive of TB')) && values[customfieldobj.mWRDreportavailableID] && (values[customfieldobj.mWRDreportavailableID] == 'No' || (values[customfieldobj.mWRDresultId] && values[customfieldobj.mWRDresultId] == 'Negative'))) {
                                //customProps = { ...customProps, className: "" };
                                if (((!values[customfieldobj.hivStatusId] || values[customfieldobj.hivStatusId] != 'Positive')) || (values[customfieldobj.hivStatusId] && values[customfieldobj.hivStatusId] == 'Positive' && values[customfieldobj.CRPreportavailableID] && (values[customfieldobj.CRPreportavailableID] == 'No' || (values[customfieldobj.CRPresultId] && values[customfieldobj.CRPresultId] == 'Negative')))) {
                                    customProps = { ...customProps, className: "" };
                                }
                            }
                        } else {

                        }
                    }
                });
            } catch (e) {

            }
            if (fieldType == "text") {
                console.log("fieldData.dataElement",fieldData.dataElement,customfieldobj.insulinName,customfieldobj.nonInsulinName  )
                if(values[customfieldobj.typeOfMedication] && values[customfieldobj.typeOfMedication] == "Other")
                    {
                        if(fieldData.dataElement.id == customfieldobj.nonInsulinName)
                            {
                                validationResult.hideShow = false
                            }
                    }

                if(values[customfieldobj.typeOfMedication] && values[customfieldobj.typeOfMedication]!= "Other")
                    {
                        if(fieldData.dataElement.id == customfieldobj.nameOfAdditionalMedication ||
                            fieldData.dataElement.id == customfieldobj.otherMedDosage 
                        )
                            {
                                validationResult.hideShow = false
                            }
                    }

                if(values[customfieldobj.typeOfMedicationRoutineVisits] && values[customfieldobj.typeOfMedicationRoutineVisits]== "Insulin") 
                    { 
                        if(fieldData.dataElement.id == customfieldobj.nameOfNonInsulinRoutineVisits) 
                            {
                                 validationResult.hideShow = false 
                            }
                    }

                if(!values[customfieldobj.typeOfMedicationRoutineVisits]) 
                    { 
                        if(fieldData.dataElement.id == customfieldobj.nameOfNonInsulinRoutineVisits || fieldData.dataElement.id == customfieldobj.nameOfAddMedicationRoutineVisits ) 
                            { 
                                validationResult.hideShow = false 
                            } 
                    } 
                    
                if(values[customfieldobj.typeOfMedicationRoutineVisits] && values[customfieldobj.typeOfMedicationRoutineVisits] == "Other") 
                    { 
                        if(fieldData.dataElement.id == customfieldobj.nameOfNonInsulinRoutineVisits) 
                            { 
                                validationResult.hideShow = false 
                            } 
                     } 
                
                if(values[customfieldobj.typeOfMedicationRoutineVisits] && values[customfieldobj.typeOfMedicationRoutineVisits]!= "Other") 
                    { 
                        if(fieldData.dataElement.id == customfieldobj.nameOfAddMedicationRoutineVisits) 
                            { 
                                validationResult.hideShow = false 
                            }
                    }

                let defaultFieldValue = '';
                if (fieldData.dataElement.fieldMask == "Default Facility") {
                    let facility = OUJSON.filter(obj => obj.id == orgid)
                    defaultFieldValue = facility && facility[0] ? facility[0].name : ''
                }
                // if (values[customfieldobj.TimeTo] > values[customfieldobj.TimeFrom]){
                //     console.log("values[customfieldobj.TimeTo]",values[customfieldobj.TimeTo],values[customfieldobj.TimeTo])
                // }
                if (fieldData.dataElement.id == customfieldobj.other)
                    validationResult.hideShow = false
                if (values[customfieldobj.reasonForTodaysVisit] &&
                    (values[customfieldobj.reasonForTodaysVisit] == "Other")) {
                    if (fieldData.dataElement.id == customfieldobj.other)
                        validationResult.hideShow = true
                }
                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                        <Field
                            name={fieldData.dataElement.id}
                            label={getTranslatedLabels(fieldData.dataElement)}
                            type={'text'}
                            component={InputFieldFF}
                            key={fieldData.dataElement.id}
                            defaultValue={defaultFieldValue}
                            required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                            validate={composeValidators(required, scriptCheck)} //fieldData.compulsory && validationResult.hideShow == true ? hasValue : false
                            value=''
                            className={customClassName}
                        />
                    </Grid>
                )
            } else if (fieldType == "radio") {
                if (values[customfieldobj.reasonForTodaysVisit] &&
                    (values[customfieldobj.reasonForTodaysVisit] == "Routine Visit" ||
                        values[customfieldobj.reasonForTodaysVisit] == "Quarterly Visit" ||
                        values[customfieldobj.reasonForTodaysVisit] == "Collecting insulin")
                ) {
                    if (
                        fieldData.dataElement.id == customfieldobj.footulcer ||
                        fieldData.dataElement.id == customfieldobj.nephropathy ||
                        fieldData.dataElement.id == customfieldobj.neuropathy ||
                        fieldData.dataElement.id == customfieldobj.retinopathy)
                        validationResult.hideShow = false
                }

                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? customClassName : 'hide'}>
                        <Radios
                            id={fieldData.dataElement.id}
                            label={getTranslatedLabels(fieldData.dataElement)}
                            name={fieldData.dataElement.id}
                            required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                            data={optionSet != null ? optionSet : []}
                            className={customClassName}
                        // defaultValue={defaultValue}
                        />
                    </Grid>
                )

            } else if (fieldType == "dropdown") {
                if (fieldData.dataElement.id == "Rc0D1mmFu8K") {
                    if (values['ZTQ487xJDkp'] == "Yes") {
                        values['Rc0D1mmFu8K'] = "Positive"
                    }

                }
                if(values[customfieldobj.typeOfMedication] && values[customfieldobj.typeOfMedication] == "Other")
                    {
                        if(fieldData.dataElement.id == customfieldobj.insulinType || 
                            fieldData.dataElement.id == customfieldobj.nonInsulinFrequency ||
                            fieldData.dataElement.id == customfieldobj.insulinFrequency || 
                            fieldData.dataElement.id == customfieldobj.insulinName 
                        )
                            {
                                validationResult.hideShow = false
                            }
                    }
                if(values[customfieldobj.typeOfMedication] && values[customfieldobj.typeOfMedication]!= "Other")
                    {
                        if(fieldData.dataElement.id == customfieldobj.otherMedFrequency)
                            {
                                validationResult.hideShow = false
                            }
                    }

                if(values[customfieldobj.typeOfMedicationRoutineVisits] && values[customfieldobj.typeOfMedicationRoutineVisits] == "Non-Insulin") 
                    { 
                        if(
                            // fieldData.dataElement.id == customfieldobj.typeOfInsulinRoutineVisits|| 
                            fieldData.dataElement.id == customfieldobj.nameOfInsulinRoutineVisits || 
                            fieldData.dataElement.id == customfieldobj.frequencyRoutineVisits ) 
                            { 
                                validationResult.hideShow = false 
                            } 
                        if(fieldData.dataElement.id == customfieldobj.frequencyOfNonInsulinRoutineVisits) 
                            { 
                                validationResult.hideShow = true 
                            } 
                   } 
                        if(values[customfieldobj.typeOfMedicationRoutineVisits] && values[customfieldobj.typeOfMedicationRoutineVisits] == "Insulin") 
                            { 
                                if(fieldData.dataElement.id == customfieldobj.frequencyOfNonInsulinRoutineVisits ) 
                                    { 
                                        validationResult.hideShow = false 
                                    } 
                                } 
                                if(!values[customfieldobj.typeOfMedicationRoutineVisits]) 
                                    { 
                                        if(fieldData.dataElement.id == customfieldobj.frequencyOfNonInsulinRoutineVisits || 
                                            fieldData.dataElement.id == customfieldobj.frequencyOfAddMedicationRoutineVisits || 
                                            fieldData.dataElement.id == customfieldobj.frequencyOfmissedDosesRoutineVisits || 
                                            fieldData.dataElement.id == customfieldobj.frequencyOfbloodGlucoseRoutineVisits ) 
                                            { 
                                                validationResult.hideShow = false 
                                            } 
                                    } 
                                    // if(values[customfieldobj.typeOfMedicationRoutineVisits] && values[customfieldobj.typeOfMedicationRoutineVisits] == "Other") 
                                    //     { 
                                    //         if(fieldData.dataElement.id == customfieldobj.typeOfInsulinRoutineVisits || 
                                    //             fieldData.dataElement.id == customfieldobj.nameOfInsulinRoutineVisits || 
                                    //             fieldData.dataElement.id == customfieldobj.frequencyRoutineVisits || 
                                    //             fieldData.dataElement.id == customfieldobj.frequencyOfNonInsulinRoutineVisits ) 
                                    //             { 
                                    //                 validationResult.hideShow = false 
                                    //             } 
                                    //     } 
                                    if(values[customfieldobj.typeOfMedicationRoutineVisits] && values[customfieldobj.typeOfMedicationRoutineVisits]!= "Other") 
                                        { 
                                            if(fieldData.dataElement.id == customfieldobj.frequencyOfAddMedicationRoutineVisits || 
                                                fieldData.dataElement.id == customfieldobj.frequencyOfmissedDosesRoutineVisits || 
                                                fieldData.dataElement.id == customfieldobj.frequencyOfbloodGlucoseRoutineVisits ) 
                                                { 
                                                    validationResult.hideShow = false 
                                                } 
                                        } 
                    
                if (fieldData.dataElement.id == customfieldobj.treatmentstartedId && customfieldobj.tptIntiationStageId) {
                    try {
                        document.querySelector('.section-1-' + customfieldobj.tptIntiationStageId).style.display = 'none'
                        if (values[customfieldobj.treatmentstartedId] == 'Yes') {
                            document.querySelector('.section-1-' + customfieldobj.tptIntiationStageId).style.display = 'block'
                        }
                    } catch (e) {

                    }
                }
                if (fieldData.dataElement.id == customfieldobj.CRPreportavailableID) {
                    customProps = { ...customProps, className: "hide", required: false, validate: false };
                    if (values && values[customfieldobj.hivStatusId] && values[customfieldobj.hivStatusId] == 'Positive') {
                        customProps = { ...customProps, className: "", required: false, validate: false };
                    }
                }
                if (fieldData.dataElement.id == customfieldobj.patientStatus) {
                    if (values && values[customfieldobj.changestatus] != 'Yes') {
                        // fieldData.dataElement.attributeValues[0].attribute.name = 'isDisabled'
                        if (APP_LOCALE === 'PRODUCT') {
                            fieldData.dataElement.attributeValues[0].attribute.name = 'isDisabled';
                        }
                    }
                    else if (values && values[customfieldobj.changestatus] == 'Yes') {
                        fieldData.dataElement.attributeValues[0].attribute.name = 'ShowInTable'
                    }
                    if (values && values[customfieldobj.patientStatus] == 'On Treatment') {
                        customProps = { ...customProps, disabled: true };
                    }
                }
                if (fieldData.dataElement.id == customfieldobj.patientStatus) {
                    if(!values[customfieldobj.changestatus]){
                        values[customfieldobj.changestatus] = "No"
                    }
                }
                console.log("customfieldobj.TimeTo",fieldData.dataElement.id,customfieldobj.TimeTo)
                

                if (fieldData.dataElement.id == customfieldobj.HaveyouhadanycontactwithTBdiseasepatientID || fieldData.dataElement.id == customfieldobj.Haveyoucomecontactwithsomeonepast5yearsID) {
                    if (values[customfieldobj.clientTypeID] && Configuration && Configuration.ltbiLinkVariables && values[customfieldobj.clientTypeID] == Configuration.ltbiLinkVariables.contact) {
                        customProps = {
                            ...customProps,
                            className: 'hide'
                        }
                    }

                }

                try {
                    if (fieldData.dataElement.id == customfieldobj.testingforTBinfectionID) {
                        if (values && values[fieldData.dataElement.id]) {
                            if (customProps && customProps.className == 'hide') {
                                delete values[fieldData.dataElement.id]
                            }
                        }
                    }

                    if (fieldData.dataElement.id == customfieldobj.eligibleforTPTId) {
                        customProps = { ...customProps, className: "hide" };
                        if (validationResult.hideShow == true && values[symptomsFID] && values[symptomsFID].includes(customfieldobj.noneOptionID) && values[customfieldobj.CXRreportavailableID] && (values[customfieldobj.CXRreportavailableID] == 'No' || (values[customfieldobj.CXRresultId] && values[customfieldobj.CXRresultId] == 'Not suggestive of TB')) && values[customfieldobj.mWRDreportavailableID] && (values[customfieldobj.mWRDreportavailableID] == 'No' || (values[customfieldobj.mWRDresultId] && values[customfieldobj.mWRDresultId] == 'Negative'))) {
                            //customProps = { ...customProps, className: "" };
                            if (((!values[customfieldobj.hivStatusId] || values[customfieldobj.hivStatusId] != 'Positive')) || (values[customfieldobj.hivStatusId] && values[customfieldobj.hivStatusId] == 'Positive' && values[customfieldobj.CRPreportavailableID] && (values[customfieldobj.CRPreportavailableID] == 'No' || (values[customfieldobj.CRPresultId] && values[customfieldobj.CRPresultId] == 'Negative')))) {
                                customProps = { ...customProps, className: "" };
                            }
                        }
                        if (values[customfieldobj.eligibleforTPTId] && values[customfieldobj.testingforTBinfectionID] && values[customfieldobj.testingforTBinfectionID] == 'Yes') {
                            delete values[fieldData.dataElement.id]
                        }

                    }
                } catch (e) {

                }
                try {
                    if (values[fieldData.dataElement.id]) {
                        let isValueExist = true;
                        isValueExist = optionSet.find(
                            (obj) => obj.value == values[fieldData.dataElement.id]
                        );
                        if (isValueExist == undefined) {
                            delete values[fieldData.dataElement.id]
                        }
                    }
                } catch (e) {

                }
                if (validationResult.hideShow == true) {
                    setFieldStructure(
                        <Grid item xs={12} sm={4} md={4} {...customProps}>
                            <Field
                                id={fieldData.dataElement.id}
                                name={fieldData.dataElement.id}
                                label={getTranslatedLabels(fieldData.dataElement)}
                                // type={fieldData.dataElement.valueType}

                                component={SingleSelectFieldFF}
                                key={fieldData.dataElement.id}
                                validate={fieldData.compulsory && validationResult.hideShow == true ? hasValue : false}
                                required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                                options={optionSet != null ? optionSet : []}
                                disabled={fieldData.dataElement.attributeValues && fieldData.dataElement.attributeValues.length > 0 ? fieldData.dataElement.attributeValues[0].attribute.name == 'isDisabled' ? true : false : false}
                                // onChange={() => this.onDropdownOptionChange(attribute.dataElement)}
                                className={customClassName}
                            />
                        </Grid>
                    )
                } else {
                    setFieldStructure(
                        <Grid item xs={12} sm={4} md={4} className={'hide'}>
                            <Field
                                name={fieldData.dataElement.id}
                                label={getTranslatedLabels(fieldData.dataElement)}
                                type={'text'}
                                component={InputFieldFF}
                                key={fieldData.dataElement.id}
                                required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                                validate={composeValidators(required, scriptCheck)} //fieldData.compulsory && validationResult.hideShow == true ? hasValue : false
                                value=''
                                className={customClassName}
                            />
                        </Grid>
                    )
                }

            }
        }


    }, [fieldType, optionSet, validationResult, localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function DateFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let customClassName = props.customClassName
    let dataElementGroup = props.dataElementGroup
    let customfieldobj = props.customfieldobj
    let showYear = fieldData.dataElement.attributeValues.length > 0 && fieldData.dataElement.attributeValues[0].attribute.name == "showyear" ? true : false
    let hideField = fieldData.dataElement.attributeValues.length > 0 && fieldData.dataElement.attributeValues[0].attribute.name == "hideField" ? true : false
    let customProps = {}
    const [fieldStructure, setFieldStructure] = useState(null)
    const [selectedDate, setDate] = useState(new Date());
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        const dataFormat1 = getDateFormat("dateformat");
        if (validationResult != null) {
            console.log("fieldData.dataElement",fieldData.dataElement)
            // try {
                // if (!values[fieldData.dataElement.id] && (fieldData.dataElement.description && fieldData.dataElement.description.trim() == "Date of last follow-up")) {
                //     values[fieldData.dataElement.id] = selectedDate

                // }
            // } catch (e) {
            //     if (!values[fieldData.dataElement.id]) {
            //         values[fieldData.dataElement.id] = selectedDate
            //     }
            // }

            const defaultDateFlagKey = `defaultdateflag_${fieldData.dataElement.id}`;
            console.log("defaultDateFlagKey", defaultDateFlagKey);
            const defaultdateflag = sessionStorage.getItem(defaultDateFlagKey);
             console.log("defaultdateflag",defaultdateflag)
             if(defaultdateflag === null)
             {
             const shouldSetDefaultDate = checkFieldCondition_dhis_(fieldData);

             if (shouldSetDefaultDate) {
                 if (values[fieldData.dataElement.id]) {
                  
                 }
                 else{
                 values[fieldData.dataElement.id] = selectedDate;
                // sessionStorage.setItem('defaultdateflag', "true");
                sessionStorage.setItem(defaultDateFlagKey, "true");
                 }
                
             } else {
                 console.log("Condition not met",defaultDateFlagKey);
             }
            }
            else if(defaultdateflag === "true")
            {
             const shouldSetDefaultDate_ = checkFieldCondition_dhis_(fieldData);

             if (shouldSetDefaultDate_) {
                 console.log("Condition met, updating date.");
                 if (values[fieldData.dataElement.id]) {
                 
                 }
                 else{
                 values[fieldData.dataElement.id] = selectedDate;
                 }
                
             } 
            }

            //
            if(fieldData.dataElement.id == customfieldobj.dateOfDiagnosis) 
                { 
                    fieldData.allowFutureDate = false 
                }
            console.log("values[customfieldobj.patientStatus]",values[customfieldobj.patientStatus], customfieldobj.dateOfLastFollowUp)
            if(fieldData.dataElement.id == customfieldobj.dateOfLastFollowUp && 
                values[customfieldobj.patientStatus] && 
                values[customfieldobj.patientStatus] != "Died" &&
                values[customfieldobj.patientStatus] != "Lost to follow up" )
                {
                    customProps = {
                        ...customProps,
                        className: "hide"
                    }
            }


            let disablePastVal = fieldData?.dataElement?.attributeValues && fieldData?.dataElement?.attributeValues.length > 0 && fieldData?.dataElement?.attributeValues.map((getAttr) => {
                if (getAttr.attribute.name && getAttr.attribute.name == "disablePastDate") {
                    return getAttr.value;
                }
            })

            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}{...customProps}>
                    <DatePicker
                        disabled={showYear ? true : false}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        name={fieldData.dataElement.id}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        dateFunsUtils={DateFnsUtils}
                        // value={values[fieldData.dataElement.id] == undefined ? selectedDate : values[fieldData.dataElement.id]}
                        margin="normal1"
                        variant="inline"
                        className={hideField ? "hide " : customClassName}
                        format={showYear == true ? "yyyy" : dataFormat1}
                        validate={fieldData.mandatory && validationResult.hideShow == true ? hasValue : false}
                        disableFuture={fieldData.allowFutureDate ? fieldData.allowFutureDate : false}
                    // disablePast={disablePastVal}
                    />
                </Grid>
            )
        }

    }, [validationResult, localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )

}

function DateTimeFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let customClassName
    let dataElementGroup = props.dataElementGroup
    let showYear = fieldData.dataElement.attributeValues.length > 0 && fieldData.dataElement.attributeValues[0].attribute.name == "showyear" ? true : false
    const [fieldStructure, setFieldStructure] = useState(null)
    const [selectedDate, setDate] = useState(new Date());
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            console.log("@here")
            const dateFormat = getDateFormat('dateformat');
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <DateTimePicker
                        disabled={showYear ? true : false}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        name={fieldData.dataElement.id}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        dateFunsUtils={DateFnsUtils}
                        value={values[fieldData.dataElement.id] == undefined ? selectedDate : values[fieldData.dataElement.id]}
                        margin="normal"
                        variant="inline"
                        format={showYear == true ? "yyyy" : dateFormat}
                        validate={selectedDate.compulsory && validationResult.hideShow == true ? hasValue : false}
                        disableFuture={fieldData.allowFutureDate ? fieldData.allowFutureDate : false}
                        className={customClassName}
                    />
                </Grid>
            )
        }

    }, [validationResult, localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )

}

function AgeFieldConfig(props) {
    const { t } = useTranslation()
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let customClassName = props.customClassName
    let dataElementGroup = props.dataElementGroup

    const required = value => (fieldData.compulsory && validationResult.hideShow == true ? value ? undefined : t('Required') : undefined)
    const mustBeNumber = value => (isNaN(value) && value ? t('Must be a number') : undefined)
    const minValue = min => value =>
        isNaN(value) || value >= min ? undefined : t('Should be greater than') + ' ' + min
    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.dataElement.id}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        type="number"
                        component={InputFieldFF}
                        key={fieldData.dataElement.id}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(required, mustBeNumber)}
                        className={customClassName}
                    />
                </Grid>
            )
        }

    }, [validationResult, localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function PhoneNumberFieldConfig(props) {
    const { t } = useTranslation()
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let customClassName = props.customClassName
    let dataElementGroup = props.dataElementGroup

    const numberFormat = value =>
        isNaN(value) && value ? `Incorrect format` : undefined

    const maxLength = max => value => value ? isNaN(value) || value.length > max ? t('Should be less than') + ' ' + max : undefined : undefined
    const required = value => (fieldData.compulsory && validationResult.hideShow == true ? value ? undefined : t('Required') : undefined)

    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.dataElement.id}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        type={'number'}
                        component={InputFieldFF}
                        key={fieldData.dataElement.id}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(required, numberFormat, maxLength(12))}
                        className={customClassName}
                    />
                </Grid>
            )
        }

    }, [validationResult, localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function EmailFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let customClassName = props.customClassName
    let dataElementGroup = props.dataElementGroup

    const EMAIL_ADDRESS_PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i

    const invalidEmailMessage = 'Please provide a valid email address'

    const email = value =>
        isEmpty(value) || (isString(value) && EMAIL_ADDRESS_PATTERN.test(value))
            ? undefined
            : invalidEmailMessage

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.dataElement.id}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        type={'email'}
                        component={InputFieldFF}
                        key={fieldData.dataElement.id}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        validate={email}
                        className={customClassName}
                    />
                </Grid>
            )
        }

    }, [validationResult, localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function DefaultValueField(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let customClassName = props.customClassName
    let dataElementGroup = props.dataElementGroup
    const [UIC, setUIC] = useState(null)

    async function getUIC() {
        if (UIC == null) {
            let getUIC = await apiServices.generateUIC(fieldData.dataElement.id)
            setUIC(getUIC.value)
        }

    }
    useEffect(() => {
        getUIC()
    }, [])

    return (
        <>
            {UIC != null ?
                <Grid item xs={12} sm={4} md={4}>
                    <Field
                        name={fieldData.dataElement.id}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        type={fieldData.dataElement.valueType}
                        component={InputFieldFF}
                        key={fieldData.dataElement.id}
                        defaultValue={UIC}
                        disabled={true}
                        className={customClassName}
                    />
                </Grid>
                :
                <> </>
            }
        </>
    )
}

function DefaultStageValueField(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let customClassName = props.customClassName
    let dataElementGroup = props.dataElementGroup
    const [randomNumber, setRandomNumber] = useState(null)

    async function getRandomNumber() {
        if (randomNumber == null) {
            let param = {
                length: 8
            }
            let getRandomNumber = await apiServices.generateRandomNumber(param)
            setRandomNumber(getRandomNumber.random)
        }

    }
    useEffect(() => {
        getRandomNumber()
    }, [])

    return (
        <>
            {randomNumber != null ?
                <Grid item xs={12} sm={4} md={4}>
                    <Field
                        name={fieldData.dataElement.id}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        type={fieldData.dataElement.valueType}
                        component={InputFieldFF}
                        key={fieldData.dataElement.id}
                        defaultValue={randomNumber}
                        disbaled={true}
                        className={customClassName}
                    />
                </Grid>
                :
                <> </>
            }
        </>
    )
}

function BooleanFieldConfig(props) {

    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let customClassName = props.customClassName
    let dataElementGroup = props.dataElementGroup
    const switchData = [
        { label: 'Yes', value: 'item1' },
    ];

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {

        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Switches
                        label={getTranslatedLabels(fieldData.dataElement)}
                        name={fieldData.dataElement.id}
                        disableRipple
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        data={switchData}
                        className={customClassName}
                    />
                </Grid>
            )
        }

    }, [validationResult, localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function TimeFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let customClassName = props.customClassName
    let dataElementGroup = props.dataElementGroup
    let showYear = fieldData.dataElement.attributeValues.length > 0 && fieldData.dataElement.attributeValues[0].attribute.name == "showyear" ? true : false
    const [fieldStructure, setFieldStructure] = useState(null)
    const [selectedDate, setDate] = useState(new Date());
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <TimePicker
                        label={fieldData.dataElement.displayFormName}
                        name={fieldData.dataElement.id}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        dateFunsUtils={DateFnsUtils}
                        margin="normal"
                        variant="inline"
                        format="HH:mm"
                        className={customClassName}
                    />
                </Grid>
            )
        }

    }, [validationResult, localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )

}

  

function IntegerConfig(props) {
   // console.log("POPS",props)
    const { t } = useTranslation()
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
   // const [values, setValues] = useState(props.values || {}); // Initialize local state

    let customClassName = props.customClassName
    let dataElementGroup = props.dataElementGroup
    let customfieldobj = props.customfieldobj
    let customProps = {}
    let programData = props.programData
    let currentstagename =props.currentstagename
    
    console.log("---currentstagename---",currentstagename)
    console.log("--fieldData--",fieldData)
    console.log("--programData--",programData.programStages)
     // const stagesList = programData.programStages
            // console.log("stagesList--->",stagesList)
      //----------------------------DYNAMIC BMI-----------------------------//      
    const [deidval, setdeidval] = useState();
    const [dataElementId, setDataElementId] = useState();
    const [weightId, setWeightId] = useState();
    const [heightId, setHeightId] = useState();
    const [bmiUnit, setBmiUnit] = useState();
    const [variableBmiId, setVariableBmiId] = useState();
    const [variableWeight, setVariableWeight] = useState();
    const [variableHeight, setVariableHeight] = useState();
    const [weight, setWeight] = useState();
    const [height, setHeight] = useState();

    const [isReadyToCalculate, setIsReadyToCalculate] = useState(false);
  
    // Function to get data element ID by attribute name
    const getDataElementIdByAttribute = (stage, attributeName) => {
        const element = stage.programStageDataElements.find(el => {
        return el.dataElement.attributeValues.some(attr => attr.attribute.name === attributeName && attr.value === 'true');
        });
        return element ? element.dataElement.id : null;
    };

    // Function to check if the stage has the CalcBMI attribute
    const hasCalcBMIAttribute = (stage) => {
        return stage.attributeValues?.some(attr => attr.attribute.name === 'CalcBMI' && attr.value === 'true');
    };

    useEffect(() => {
        const currentStage = programData.programStages.find(stage => stage.name === currentstagename);
            if (currentStage && hasCalcBMIAttribute(currentStage)) {
                const deId = getDataElementIdByAttribute(currentStage, "BMIFlag");
                const wtId = getDataElementIdByAttribute(currentStage, "WeightForBMI");
                const htId = getDataElementIdByAttribute(currentStage, "HeightForBMI");
                console.log("BMIATTRIBUTEVALUES",deId,wtId,htId)
            
            
                if (deId && wtId && htId) { 
                    setdeidval(deId)
                    const getbmifieldidkey = getKeyByValue(customfieldobj, deId);
                    const getweightidkey = getKeyByValue(customfieldobj, wtId);
                    const getheightidkey = getKeyByValue(customfieldobj, htId);
                    console.log("Field keys:", getbmifieldidkey, getweightidkey, getheightidkey);
            
                

                    const unit = getAttributeValue(programData.attributeValues, "BMIUnit");
            
                    setDataElementId(getbmifieldidkey);
                    setWeightId(getweightidkey);
                    setHeightId(getheightidkey);
                    setBmiUnit(unit);
                    setWeight(customfieldobj[weightId]);
                    setHeight(customfieldobj[heightId]);
                } else {
                    console.log("One or more IDs are undefined:", deId, wtId, htId);
                }
            }
    }, [fieldData,customfieldobj, values, programData]);

    // Fetch unit when programData changes
    useEffect(() => {
        const unit = getAttributeValue(programData.attributeValues, "BMIUnit");
        setBmiUnit(unit);
    }, [programData]);


    useEffect(() => {
        console.log("CUSTFALD",weight,height)
        if (weight && height) {
            
            console.log("Customdataelementid-gYWT3GGhxa3",dataElementId)
            const variableBmiid =customfieldobj[dataElementId];
            const variableweight= values[customfieldobj[weightId]];
            const variableheight= values[customfieldobj[heightId]];
            console.log("IN HERE",variableweight,variableheight,variableBmiid,fieldData.dataElement.id )
            
           
                    console.log()
                    if(fieldData.dataElement.id == variableBmiid && variableweight && variableheight){
                    if (!variableweight || !variableheight || variableweight === undefined || variableheight === undefined) {
                        console.log("Weight or height is missing, resetting BMI.");
                        values[variableBmiid] = "";
                        customProps = {
                            ...customProps,
                            key: Math.random() * 9999
                        };
                    } else {
                       
                        // If weight and height are both provided, calculate the BMI
                        const calculatedBMI = dynamiccalculateBMI(variableweight, variableheight, bmiUnit);
                         console.log("Calculated BMI:", calculatedBMI,variableBmiid,values);
                        
                      values[variableBmiid] = calculatedBMI;
                    //    values["WEHrA7SXHBe"]= calculatedBMI;
                    //     values["gYWT3GGhxa3"] = calculatedBMI;
                    //   values["hTtV3yj4ZQ7"]= calculatedBMI;
                    //   values["Rq9Mjh2N0EK"] = calculatedBMI;
                      
                        customProps = {
                            ...customProps,
                            key: Math.random() * 9999
                        };
                        
                    }
                }
                else
                {
                    console.log("Weight or height is missing, resetting BMI.");
                    values[variableBmiid] = "";
                    customProps = {
                        ...customProps,
                        key: Math.random() * 9999
                    };
                }

        }
     }, [fieldData,customfieldobj, values, programData]);


    //-----------------------------------------------------------------------------//
    const decimalregex = /^\d+(\.\d{1,2})?$/;
    const required = value => (fieldData.compulsory && validationResult.hideShow == true ? value ? undefined : t('Required') : undefined)
    const mustBeNumber = value => (isNaN(value) && value ? t('Must be a number') : undefined)
    const minValue = min => value =>
        isNaN(value) || value >= min ? undefined : t('Should be greater than/equal to') + ' ' + min

    const maxValue = max => value =>
        isNaN(value) || value <= max ? undefined : t('Should be less than') + ' ' + max
    const maxLength = max => value => value ? isNaN(value) || value.length > max ? t('Should be less than') + ' ' + (max + 1) + " " + 'digits' : undefined : undefined
    const validateDecimalPlaces = value => value ? isNaN(value) || decimalregex.test(value) ? undefined : t('Should be less than 3 decimal places') : undefined;

    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    function calculateAge(Date1, Date2) {
        let dt2 = new Date(Date1);
        let dt1 = new Date(Date2).toISOString();

        var a = moment(dt2);
        var b = moment(dt1);

        var years = a.diff(b, "years");
        var birth = Math.abs(years);
        var age = Math.abs(years);
        console.log("years", age);
        return age == 0 || dt2 > dt1 ? "0" : age;
    }

    function calculateBMI(weightKg, heightCm) {
        console.log("calculateBMI123", weightKg, heightCm)
        // Convert height from centimeters to meters
        const heightM = heightCm / 100;

        // Calculate BMI
        let bmi = weightKg / (heightM * heightM);
        bmi = bmi.toFixed(2);
        console.log("bmi", bmi)
        return bmi;
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            // Fields to be hidden for value "Annual visit"
            if (values[customfieldobj.reasonForTodaysVisit] &&
                (values[customfieldobj.reasonForTodaysVisit] == "Routine Visit" ||
                    values[customfieldobj.reasonForTodaysVisit] == "Quarterly Visit" ||
                    values[customfieldobj.reasonForTodaysVisit] == "Collecting insulin")
            ) {
                if (fieldData.dataElement.id == customfieldobj.microalbuminuriaTestForNephropathy ||
                    fieldData.dataElement.id == customfieldobj.creatinine ||
                    fieldData.dataElement.id == customfieldobj.totalCholestrol ||
                    fieldData.dataElement.id == customfieldobj.ldlCholestrol ||
                    fieldData.dataElement.id == customfieldobj.hdlCholestrol ||
                    fieldData.dataElement.id == customfieldobj.triglyceride ||
                    fieldData.dataElement.id == customfieldobj.TSH ||
                    fieldData.dataElement.id == customfieldobj.freeT4 ||
                    fieldData.dataElement.id == customfieldobj.thyroidPeroxidaseAntibody ||
                    fieldData.dataElement.id == customfieldobj.footulcer ||
                    fieldData.dataElement.id == customfieldobj.nephropathy ||
                    fieldData.dataElement.id == customfieldobj.neuropathy ||
                    fieldData.dataElement.id == customfieldobj.retinopathy ||
                    fieldData.dataElement.id == customfieldobj.fundusPhotography ||
                    fieldData.dataElement.id == customfieldobj.totalCholestrol || 
                    fieldData.dataElement.id == customfieldobj.myocardialInfarction || 
                    fieldData.dataElement.id == customfieldobj.cerebrovascularAccident)
                    customProps = {
                        ...customProps,
                        className: "hide"
                    }
            }
            console.log("HbA1c", customfieldobj.HbA1c)
            if (values[customfieldobj.reasonForTodaysVisit] &&
                (values[customfieldobj.reasonForTodaysVisit] == "Routine Visit" ||
                    values[customfieldobj.reasonForTodaysVisit] == "Collecting insulin")
            ) {
                if (fieldData.dataElement.id == customfieldobj.HbA1c)
                    customProps = {
                        ...customProps,
                        className: "hide"
                    }
            }
            console.log("fieldData.dataElement.id",fieldData.dataElement)
            if(values[customfieldobj.typeOfMedication] && values[customfieldobj.typeOfMedication] == "Other")
                {
                    if(fieldData.dataElement.id == customfieldobj.nonInsulinDosage || 
                        fieldData.dataElement.id == customfieldobj.insulinDosage ||
                        fieldData.dataElement.id == customfieldobj.courseOfDays 
                    )
                        {
                            validationResult.hideShow = false
                        }
                }


                
            // if (fieldData.dataElement.id == customfieldobj.bmiID && values[customfieldobj.weightID] && values[customfieldobj.heightID]) {
            //     // console.log("calculateBMI1234", values, customfieldobj)

            //     values[customfieldobj.bmiID] = calculateBMI(values[customfieldobj.weightID], values[customfieldobj.heightID])
            //     customProps = {
            //         ...customProps,
            //         key: Math.random() * 9999
            //     }
            // }
            
            // if (fieldData.dataElement.id == customfieldobj.bmiID1 && values[customfieldobj.weightID1] && values[customfieldobj.heightID1]) {
            //     values[customfieldobj.bmiID1] = calculateBMI(values[customfieldobj.weightID1], values[customfieldobj.heightID1])
            //     customProps = {
            //         ...customProps,
            //         key: Math.random() * 9999
            //     }
            // }

            if(values[customfieldobj.typeOfMedicationRoutineVisits] && values[customfieldobj.typeOfMedicationRoutineVisits] == "Other") 
                { 
                    if(fieldData.dataElement.id == customfieldobj.dosageRoutineVisits || 
                        fieldData.dataElement.id == customfieldobj.courseOfDaysOfRoutineVisits || 
                        fieldData.dataElement.id == customfieldobj.dosageOfNonInsulinRoutineVisits ) 
                        { 
                            validationResult.hideShow = false 
                        } 
                } 
                
            if(values[customfieldobj.typeOfMedicationRoutineVisits] && values[customfieldobj.typeOfMedicationRoutineVisits]== "Insulin") 
                { 
                    if(fieldData.dataElement.id == customfieldobj.dosageOfNonInsulinRoutineVisits || 
                        fieldData.dataElement.id == customfieldobj.dosageOfAddMedicationRoutineVisits || 
                        fieldData.dataElement.id == customfieldobj.noOfMealsRoutineVisits ) 
                        { 
                            validationResult.hideShow = false 
                        } 
                } 
                    
            if(values[customfieldobj.typeOfMedicationRoutineVisits] && values[customfieldobj.typeOfMedicationRoutineVisits]== "Non-Insulin") 
                { 
                    if(fieldData.dataElement.id == customfieldobj.dosageRoutineVisits ||
                         fieldData.dataElement.id == customfieldobj.courseOfDaysOfRoutineVisits || 
                         fieldData.dataElement.id == customfieldobj.dosageOfAddMedicationRoutineVisits || 
                         fieldData.dataElement.id == customfieldobj.noOfMealsRoutineVisits ) 
                         { 
                            validationResult.hideShow = false 
                         } 
                         
            if(fieldData.dataElement.id == customfieldobj.dosageOfNonInsulinRoutineVisits) 
                { 
                    validationResult.hideShow = true 
                } 

            } 
            
            if(!values[customfieldobj.typeOfMedicationRoutineVisits]) 
                { 
                    if(fieldData.dataElement.id == customfieldobj.dosageOfNonInsulinRoutineVisits || 
                        fieldData.dataElement.id == customfieldobj.dosageOfAddMedicationRoutineVisits || 
                        fieldData.dataElement.id == customfieldobj.noOfMealsRoutineVisits ) 
                        {
                             validationResult.hideShow = false
                         } 
                }

            let fieldDisabled = false;
            if (fieldData.dataElement.id == customfieldobj.ageAtDeath && values[customfieldobj.dateOfDeath]) {
                try {
                    values[fieldData.dataElement.id] = calculateAge(values[customfieldobj.dateOfDeath], values[customfieldobj.dobID]);
                    fieldDisabled = true;
                    customProps = {
                        ...customProps,
                        key: Math.random() * 9999,
                        disabled: true
                    };
                } catch (e) {

                }
            }
            if (fieldData.dataElement.id == customfieldobj.durationInCDIC && values[customfieldobj.registrationDate]) {
                try {
                    values[fieldData.dataElement.id] = calculateAge(values[customfieldobj.dateOfRollOut], values[customfieldobj.registrationDate] );
                    fieldDisabled = true;
                    customProps = {
                        ...customProps,
                        key: Math.random() * 9999,
                        disabled: true
                    };
                } catch (e) {
                }
            }

            if (fieldData.dataElement.id == customfieldobj.durationOfDiabetes && values[customfieldobj.dateOfDiagnosis]) {
                try {
                    values[fieldData.dataElement.id] = calculateAge(values[customfieldobj.dateOfRollOut], values[customfieldobj.dateOfDiagnosis] );
                    fieldDisabled = true;
                    customProps = {
                        ...customProps,
                        key: Math.random() * 9999,
                        disabled: true
                    };
                } catch (e) {
                }
            }
            


            if (fieldData.dataElement.id == customfieldobj.pulsebpm) {

                customProps = {
                    ...customProps,
                    validate: composeValidators(required, mustBeNumber, maxLength(3)),
                };
            }
            if (fieldData.dataElement.id == customfieldobj.HbA1c) {
                customProps = {
                    ...customProps,
                    validate: composeValidators(required, mustBeNumber, validateDecimalPlaces),
                };
            }
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.dataElement.id}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        type={'number'}
                        component={InputFieldFF}
                        key={fieldData.dataElement.id}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(required, mustBeNumber,minValue(fieldData.dataElement.id!= customfieldobj.durationInCDIC && fieldData.dataElement.id!= customfieldobj.durationOfDiabetes?1:0))}
                        value=''
                        className={customClassName}
                        {...customProps}
                    />
                </Grid>
            )
        }

    }, [validationResult, localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function TextAreaConfig(props) {
    const { t } = useTranslation()
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let customClassName = props.customClassName
    let dataElementGroup = props.dataElementGroup

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    const required = value => (fieldData.compulsory && validationResult.hideShow == true ? value ? undefined : t('Required') : undefined)
    const scriptCheck = value => (value ? value.match(/<[^>]*>/g) != null ? t('Incorrect expression "< or >" added as input') : undefined : undefined)
    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.dataElement.id}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        type={'text'}
                        component={InputFieldFF}
                        key={fieldData.dataElement.id}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(required, scriptCheck)}
                        autoGrow
                        className={customClassName}
                    />
                </Grid>
            )
        }

    }, [validationResult, localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function UserNameConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let customClassName = props.customClassName
    let dataElementGroup = props.dataElementGroup
    let orgunitid = props.programorgid
    const [dropdownOptions, setDropdownOptions] = useState([])
    const setGlobalSpinner = useGlobalSpinnerActionsContext()
    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }
    function fetchCustomUsersList() {

        setGlobalSpinner(true)
        let options = [];
        apiServices.getAPI('users?paging=true&page=1&pageSize=10&query=&fields=firstName,surname,userCredentials[username],id&ou=' + orgunitid)
            .then(response => {
                setGlobalSpinner(false)

                response.data.users.map(user => {
                    let obj = {
                        'id': user.id,
                        'label': user.firstName + " " + user.surname,
                        'value': user.id,
                    }
                    options.push(obj)
                    setDropdownOptions(options)
                    setGlobalSpinner(false)
                })
            }).catch(err => {
                setGlobalSpinner(false)

            })

    }
    useEffect(() => {
        fetchCustomUsersList();
    }, [])
    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null && dropdownOptions.length > 0) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    {/* old code commented
                    <Field
                        name={fieldData.dataElement.id}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        component={TextAreaFieldFF}
                        key={fieldData.dataElement.id}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(hasValue, dhis2Username)}
                    /> */}
                    <Field
                        id={fieldData.dataElement.id}
                        name={fieldData.dataElement.id}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        component={SingleSelectFieldFF}
                        key={fieldData.dataElement.id}
                        validate={fieldData.compulsory && validationResult.hideShow == true ? hasValue : false}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        options={dropdownOptions}
                        disabled={fieldData.dataElement.attributeValues && fieldData.dataElement.attributeValues.length > 0 ? fieldData.dataElement.attributeValues[0].attribute.name == 'isDisabled' ? true : false : false}
                        className={customClassName}
                    />
                </Grid>
            )
        }

    }, [validationResult, dropdownOptions, localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function URLConfig(props) {
    const { t } = useTranslation()
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let customClassName = props.customClassName
    let dataElementGroup = props.dataElementGroup
    let regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    const required = value => (fieldData.compulsory && validationResult.hideShow == true ? value ? undefined : t('Required') : undefined)

    const URLCheck = value => (regexp.test(value) ? undefined : t('Incorrect URL format'))

    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    {getTranslatedLabels(fieldData.dataElement)} :
                    <a target='_blank' href={values[fieldData.dataElement.id]}>URL</a>
                    {/* <Field
                        name={fieldData.dataElement.id}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        component={TextAreaFieldFF}
                        key={fieldData.dataElement.id}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(required, URLCheck)}
                    /> */}
                </Grid>
            )
        }

    }, [validationResult, localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function HandleOUOptions(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let customClassName = props.customClassName
    let OUMappingList = OUMapping(values)
    let parentValue = OUMappingList[fieldData.dataElement.id] != undefined ? values[OUMappingList[fieldData.dataElement.id].parent] : null
    let programData = props.programData
    let options = props.options
    let defaultOption = props.defaultOption
    let rules = {
        "programRule": props.programRules,
        "programRuleVariable": props.programRulesVariables
    }
    let OUJSON = props.OUJSON.organisationUnits

    if (fieldData.dataElement.displayName == "Referral facility" || fieldData.dataElement.displayName == "Sample transferred to facility ") {
        OUJSON = OUJSON.filter(obj => obj.comment == "Facility")
    }

    const option = { "id": "option1", "label": 'Option1', "value": 'option1' }

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)
    const [location, setLocation] = useState([])

    const setGlobalSpinner = useGlobalSpinnerActionsContext()

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }

    useEffect(() => {



        if (options != '') {
            let locationList = []
            const filterOnId = OUJSON.filter(obj => obj.id == options)
            if (filterOnId.length > 0) {
                const childrenOptions = filterOnId[0].children
                childrenOptions.map(childOptions => {
                    const filterChildDetails = OUJSON.filter(obj => obj.id == childOptions.id)
                    if (filterChildDetails.length > 0) {
                        let obj = {
                            'id': filterChildDetails[0].id,
                            'label': filterChildDetails[0].name,
                            'value': filterChildDetails[0].id,
                        }
                        locationList.push(obj)
                        setLocation(locationList)
                    }

                })

            }
            if (fieldData.dataElement.displayName == "Referral facility" || fieldData.dataElement.displayName == "Sample transferred to facility ") {

                OUJSON.map(facility => {
                    let obj = {
                        'id': facility["id"],
                        'label': facility["name"],
                        'value': facility["id"],
                    }
                    locationList.push(obj)
                    locationList = _.orderBy(locationList, ['label'], ['asc'])
                    setLocation(locationList)
                })
            }
        } else {
            const OUList = programData.organisationUnits
            let autocompleteData = []

            if (OUMappingList[fieldData.dataElement.id] != undefined) {
                if (OUMappingList[fieldData.dataElement.id].type) {

                    let OUOptions = OUJSON.filter(obj => obj.level == OUMappingList[fieldData.dataElement.id].level)
                    if (OUOptions.length > 0) {
                        OUOptions.map(items => {
                            let obj = {
                                'id': items.id,
                                'label': items.name,
                                'value': items.id
                            }
                            autocompleteData.push(obj)
                        })
                        setLocation(autocompleteData)
                    }
                }
            } else {
                let OUOptions = OUJSON;
                OUOptions = OUJSON.filter((obj) => obj.comment == "Facility");
                if (OUOptions.length > 0) {
                    OUOptions.map((items) => {
                        let obj = {
                            id: items.id,
                            label: items.name,
                            value: items.id,
                        };
                        autocompleteData.push(obj);
                    });
                    setLocation(autocompleteData);
                }
            }
            if (fieldData.dataElement.displayName == "Referral facility" || fieldData.dataElement.displayName == "Sample transferred to facility ") {

                OUJSON.map(facility => {
                    let obj = {
                        'id': facility["id"],
                        'label': facility["name"],
                        'value': facility["id"],
                    }
                    autocompleteData.push(obj)
                    autocompleteData = _.orderBy(autocompleteData, ['label'], ['asc'])
                    setLocation(autocompleteData)
                })
            }


        }

    }, [values[fieldData.dataElement.id], parentValue, options, localStorage.getItem("locale")]) //defaultOption, options

    useEffect(() => {
        if (location != null) {
            if (values[fieldData.dataElement.id]) {
                if (!_.isEmpty(defaultOption)) {
                    setFieldStructure(
                        <OUFieldConfig
                            data={fieldData} values={values} rules={rules} options={location} defaultOption={defaultOption} programData={programData} OUMapping={OUMappingList} customClassName={customClassName}
                        />
                    )
                }
            } else {
                setFieldStructure(
                    <OUFieldConfig
                        data={fieldData} values={values} rules={rules} options={location} defaultOption={defaultOption} programData={programData} OUMapping={OUMappingList} customClassName={customClassName}
                    />
                )
            }
        }


    }, [location, localStorage.getItem("locale")])
    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function ReferalConfig(props) {
    let fieldData = props.fieldData

    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let customClassName = props.customClassName
    let dataElementGroup = props.dataElementGroup
    let programData = props.programData
    let customfieldobj = props.customfieldobj
    let programBoDetails = props.programBoDetails
    let referralWorkFlow = programBoDetails && programBoDetails.isReferralWorkflow ? true : false
    let symptomsFID = props.symptomsFID ? props.symptomsFID : ''
    let Configuration = props.Configuration
    //console.log("programBoDetails ",programBoDetails,referralWorkFlow);
    const stagesList = programData.programStages
    const { t } = useTranslation()
    const [referralDefaultValue, setReferralDefaultValue] = useState(null)
    let checkboxData = [];
    let isCheckboxReadOnly = false, readOnlyCheckboxArr = []

    let ReferToLabForinvestigationFieldValue = values[customfieldobj.referToId] ? values[customfieldobj.referToId] : undefined
    //console.log("ee ",ReferToLabForinvestigationFieldValue,customfieldobj.referToId,customfieldobj.selectReferralServiceId);
    let defaultval = '';

    let testingStage = customfieldobj.tbTestingStageId //stagesList.filter(obj => obj.description == "Testing Form")
    let tbInfectionTestingStage = customfieldobj.tbInfectionTestingStageId //stagesList.filter(obj => obj.description == "TB Treatment Initiation") //ltbi
    let tptInitiation = customfieldobj.tptIntiationStageId //stagesList.filter(obj => obj.description == "TPT  Initiation Form") //TPT ltbi
    if (referralWorkFlow) {
        if (testingStage && testingStage.length > 0) {
            if (ReferToLabForinvestigationFieldValue == 'TB' || ReferToLabForinvestigationFieldValue == 'LTBI') {
                defaultval = testingStage //testingStage[0].id
            }

        }

        if (values[customfieldobj.eligibleforTPTId] == 'Yes' && values[customfieldobj.testingforTBinfectionID] == 'No') { //&& values[customfieldobj.testingforTBinfectionID] == 'No'
            defaultval = tptInitiation //tptInitiation[0].id
        } else if (values[customfieldobj.mWRDresultId] == 'Negative' && values[customfieldobj.mWRDreportavailableID] == 'Yes') {
            defaultval = tbInfectionTestingStage
        } else if (values[customfieldobj.mWRDresultId] == 'Positive' && values[customfieldobj.mWRDreportavailableID] == 'Yes') {
            defaultval = customfieldobj.tbTretmentInitiationStageId
        } else if ((values[customfieldobj.CXRreportavailableID] == 'Yes' && values[customfieldobj.CXRresultId] == 'Suggestive of TB') || (values[customfieldobj.CRPreportavailableID] == 'Yes' && values[customfieldobj.CRPresultId] == 'Positive') || (symptomsFID && values[symptomsFID] && _.isArray(values[symptomsFID]) && values[symptomsFID].length > 0 && !values[symptomsFID].includes(customfieldobj.noneOptionID))) {
            defaultval = testingStage //tbTestingStage[0].id
        } else {
            if (values[customfieldobj.CXRresultId] == 'Not suggestive of TB' || values[customfieldobj.mWRDreportavailableID] == 'No' || (symptomsFID && values[symptomsFID] && _.isArray(values[symptomsFID]) && values[symptomsFID].length > 0 && values[symptomsFID].includes(customfieldobj.noneOptionID))) {
                defaultval = tbInfectionTestingStage//testingStage
            } else {
                defaultval = tbInfectionTestingStage
            }
            //defaultval =  testingStage //tbInfectionTestingStage //tbInfectionTestingStage[0].id
        }

        // if(values[customfieldobj.mWRDresultId] == 'Positive' && values[customfieldobj.mWRDreportavailableID] == 'Yes'){
        //     defaultval =  customfieldobj.tbTretmentInitiationStageId
        // }else if(values[customfieldobj.CXRresultId] == 'Suggestive of TB' || values[customfieldobj.CRPresultId] == 'Positive' || (symptomsFID && values[symptomsFID]  && _.isArray(values[symptomsFID]) && values[symptomsFID].length > 0 && !values[symptomsFID].includes(customfieldobj.noneOptionID))){
        //     defaultval = testingStage //tbTestingStage[0].id
        // }else if(values[customfieldobj.eligibleforTPTId] == 'Yes' && values[customfieldobj.testingforTBinfectionID] == 'No'){ //&& values[customfieldobj.testingforTBinfectionID] == 'No'
        //     defaultval =  tptInitiation //tptInitiation[0].id
        // }else{
        //     if(values[customfieldobj.CXRresultId] == 'Not suggestive of TB' || values[customfieldobj.mWRDreportavailableID] == 'No' || (symptomsFID && values[symptomsFID]  && _.isArray(values[symptomsFID]) && values[symptomsFID].length > 0 && values[symptomsFID].includes(customfieldobj.noneOptionID))){
        //         defaultval =  testingStage
        //     }
        //     //defaultval =  testingStage //tbInfectionTestingStage //tbInfectionTestingStage[0].id
        // }

        if (values && customfieldobj.selectReferralServiceId == fieldData.dataElement.id) {
            if (!values[customfieldobj.selectReferralServiceId]) {
                values[customfieldobj.selectReferralServiceId] = '' //[];
            }
            if (defaultval) {
                //values[customfieldobj.selectReferralServiceId] = '' //[];
                values[customfieldobj.selectReferralServiceId] = defaultval //.push(defaultval);
            }
        }
        // if(values[customfieldobj.selectReferralServiceId] && _.isArray(values[customfieldobj.selectReferralServiceId])){
        //     values[customfieldobj.selectReferralServiceId] = values[customfieldobj.selectReferralServiceId][0]
        // }
        if (values[customfieldobj.selectReferralServiceId] && _.isArray(values[customfieldobj.selectReferralServiceId])) {
            values[customfieldobj.selectReferralServiceId] = tbInfectionTestingStage ? tbInfectionTestingStage : values[customfieldobj.selectReferralServiceId][0]
        }

        if (Configuration && Configuration.ltbiLinkVariables && values[customfieldobj.clientTypeID] == Configuration.ltbiLinkVariables.index) {
            values[customfieldobj.selectReferralServiceId] = customfieldobj.tbTretmentInitiationStageId
        }
    } else {
        //radio type
        // if(values[customfieldobj.selectReferralServiceId] && _.isArray(values[customfieldobj.selectReferralServiceId])){
        //     values[customfieldobj.selectReferralServiceId] = values[customfieldobj.selectReferralServiceId][0]
        // }
        if (values[customfieldobj.selectReferralServiceId] && _.isArray(values[customfieldobj.selectReferralServiceId])) {
            values[customfieldobj.selectReferralServiceId] = tbInfectionTestingStage ? tbInfectionTestingStage : values[customfieldobj.selectReferralServiceId][0]
        }
    }

    //defaultvalue
    // if(!values[customfieldobj.selectReferralServiceId]){
    //     values[customfieldobj.selectReferralServiceId] = testingStage
    // }
    if (!values[customfieldobj.selectReferralServiceId]) {
        values[customfieldobj.selectReferralServiceId] = tbInfectionTestingStage ? tbInfectionTestingStage : testingStage//testingStage
    }

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    function getFieldDetails(stage, parentAttribute, parentReadOnlyCheckboxArr) {
        console.log("Called",stage)
        let customProps = {}
        if (referralWorkFlow) {
            customProps = { ...customProps }
            customProps.disabled = true//false
            //customProps.initialValue = parentReadOnlyCheckboxArr
            if (defaultval) {
                customProps.initialValue = [defaultval]
            }
        }
        return (
            <>
                <Field
                    type="radio"
                    component={RadioFieldFF}
                    name={parentAttribute.dataElement.id}
                    label={stage.label}
                    value={stage.value}
                    //initialValue={parentReadOnlyCheckboxArr}
                    {...customProps}
                    className={customClassName}
                />
                <OnChange name={parentAttribute.dataElement.id}>
                    {(value, previous) => {
                        if (!defaultval) {
                            values[customfieldobj.selectReferralServiceId] = value
                        }
                    }}
                </OnChange>
            </>

        );
    };

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            stagesList.map((stage) => {
                // readynoly checkbox logic for savemynmar
                if (stage.attributeValues.length > 0) {
                    stage.attributeValues.map((val) => {

                        if (val.attribute.displayName == "showStageNameInReferralService" && val.value == 'true') {
                            if (stage.id == defaultval) {
                                readOnlyCheckboxArr.push(stage.id)
                            }
                            isCheckboxReadOnly = true;
                            checkboxData.push({
                                label: stage.displayName ? t(stage.displayName) : t(stage.description),
                                value: stage.id,
                            });
                        }
                    })
                }
            })

            setFieldStructure(
                <Grid item xs={12} sm={4} className={validationResult.hideShow == true ? 'customLoc ' + customClassName : 'hide'}>
                    <FieldGroupFF
                        label={getTranslatedLabels(fieldData.dataElement)}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        name={fieldData.dataElement.id}
                        className={customClassName}
                    >
                        {checkboxData.map((stage) => {
                            return getFieldDetails(stage, fieldData, readOnlyCheckboxArr);
                        })}
                    </FieldGroupFF>
                </Grid>
            )
        }

    }, [validationResult, localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function MultiSelectConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let customClassName = props.customClassName
    let DataElementGroup = props.DataElementGroup
    let customfieldobj = props.customfieldobj
    let programObj = props.programObj
    let dataElementGroup = props.dataElementGroup
    let stage = props.stages
    let noneFieldId = customfieldobj.noneOptionID//"ATGexAEZ8xm"
    //console.log("noneFieldId ",noneFieldId);
    let customProps = {}
    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    function getFieldDetails(fieldId, formValues) {
        const getFieldsAttributes = stage.filter(
            (obj) => obj.dataElement.id == fieldId
        );

        if (getFieldsAttributes.length > 0) {

            const fieldData1 = getFieldsAttributes[0];
            const findField = fieldData1.dataElement.id;
            let isFieldDisbaled = false;
            let autoChecked = false;
            try {
                if (findField != undefined && formValues[findField]) {
                    if (values[DataElementGroup.id] && _.isArray(values[DataElementGroup.id]) && _.last(values[DataElementGroup.id]) && _.last(values[DataElementGroup.id]) != noneFieldId) {
                        if (values[findField] == true && findField != noneFieldId) {
                            //console.log("if ",noneFieldId,DataElementGroup.id,findField,values[DataElementGroup.id]);
                            if (values[DataElementGroup.id] && (values[DataElementGroup.id].includes(noneFieldId))) {
                                values[DataElementGroup.id] = values[DataElementGroup.id].filter(item => item !== noneFieldId)
                            }
                            //values[noneFieldId] = false
                            delete values[noneFieldId]
                        }
                    } else if (values[DataElementGroup.id] && _.isArray(values[DataElementGroup.id]) && _.last(values[DataElementGroup.id]) && _.last(values[DataElementGroup.id]) == noneFieldId) {
                        //console.log("else ",noneFieldId,DataElementGroup.id,findField,values[DataElementGroup.id]);
                        values[DataElementGroup.id].map(ele => {
                            if (ele != noneFieldId)
                                delete values[ele]
                        })
                        values[DataElementGroup.id] = [noneFieldId]
                    }
                }
            } catch (e) {

            }
            // if (findField != undefined && findField != noneFieldId) {
            //     if (formValues[noneFieldId] == true && values[DataElementGroup.id] && values[DataElementGroup.id].includes(noneFieldId)) {
            //       //let indexOfEle = formValues[DataElementGroup.id].indexOf(findField);
            //       isFieldDisbaled = true;
            //       autoChecked = true;
            //       if(formValues[fieldData1.dataElement.id]){
            //           if(values[DataElementGroup.id] && values[DataElementGroup.id].includes(fieldData1.dataElement.id)){
            //               values[DataElementGroup.id] = values[DataElementGroup.id].filter(item => item !== fieldData1.dataElement.id)
            //           }
            //          delete formValues[fieldData1.dataElement.id]
            //         //formValues[DataElementGroup.id].splice(indexOfEle, 1);
            //       }
            //     }
            //   }else{

            //   }
            return (
                autoChecked == true ?
                    <Field
                        component={CheckboxFieldFF}
                        name={DataElementGroup.id}
                        disabled={isFieldDisbaled}
                        label={getTranslatedLabels(fieldData1.dataElement)}
                        value={fieldData1.dataElement.id}
                        initialValue={formValues[DataElementGroup.id]}
                        className={customClassName}
                    />
                    :
                    <Field
                        type="checkbox"
                        component={CheckboxFieldFF}
                        name={DataElementGroup.id}
                        // disabled={isFieldDisbaled}
                        label={getTranslatedLabels(fieldData1.dataElement)}
                        value={fieldData1.dataElement.id}
                        initialValue={formValues[DataElementGroup.id]}
                        className={customClassName}
                    />
            );
        }
    }

    useEffect(() => {
        fetchValidation()

    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            let fieldLabel = getTranslatedLabels(DataElementGroup);
            try {
                if (fieldLabel.includes('_')) {
                    let l = fieldLabel.split('_');
                    fieldLabel = l[1]
                }
            } catch (e) {

            }
            setFieldStructure(
                <Grid item xs={12} sm={4} className={validationResult.hideShow == true ? 'customLoc ' + customClassName : 'hide'}>
                    <FieldGroupFF
                        label={fieldLabel}
                        // onClick={(e, v) => onChange(e, v)}
                        name={DataElementGroup.id}
                        className={customClassName}
                    >
                        {DataElementGroup.dataElements.map((field) => {
                            return getFieldDetails(field.id, values);
                        })}
                    </FieldGroupFF>
                </Grid>
            )
        }

    }, [validationResult, localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )

}
function QrCodeScanner(props) {

    let fieldData = props.fieldData

    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values

    const [fieldStructure, setFieldStructure] = useState(null)
    const [showScannner, setShowScannner] = useState(false)
    const [defaultValue, setDefaultValue] = useState(null)

    function qrErrorhandler() {
        setShowScannner(false)
    }

    function handleQRScan(data) {
        if (data) {
            setShowScannner(false)
            setDefaultValue(data)
        }
    }

    function closeQrSacnner() {
        setShowScannner(false)
    }
    function openCordovaQrScanner() {

        let that = this;
        window.cordova.plugins.barcodeScanner.scan(
            function (result) {
                handleQRScan(result.text);
                //setShowScannner(false)
                //setDefaultValue(result.text)
            },
            function (error) {

            },
            {
                preferFrontCamera: false, // iOS and Android
                showFlipCameraButton: true, // iOS and Android
                showTorchButton: false, // iOS and Android
                torchOn: false, // Android, launch with the torch switched on (if available)
                prompt: 'Place a barcode inside the scan area', // Android
                resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
                //formats : "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
                //orientation : "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
                disableAnimations: true, // iOS
                disableSuccessBeep: false // iOS
            }
        );
    }
    function openQrSacnner() {
        if (window.cordova) {
            openCordovaQrScanner()
        } else {
            setShowScannner(true)
        }
    }

    useEffect(() => {
        if (showScannner) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} >
                    <div style={{ display: 'none' }}>
                        <Field
                            name={fieldData.dataElement.id}
                            label={getTranslatedLabels(fieldData.dataElement)}
                            type={fieldData.dataElement.valueType}
                            component={InputFieldFF}
                            key={fieldData.dataElement.id}
                            defaultValue={defaultValue}
                        />
                    </div>
                    <div style={{ height: '200px', width: '200px' }}>

                        <Html5QrcodePlugin
                            fps={10}
                            qrbox={200}
                            disableFlip={false}
                            qrCodeSuccessCallback={(e) => handleQRScan(e)} />
                        <span onClick={() => closeQrSacnner()}>
                            <FontAwesomeIcon icon={faTimes} />
                        </span>
                    </div>
                    {/* <div>
                        <QrReader
                            delay={300}
                            onError={qrErrorhandler}
                            onScan={handleQRScan}
                            style={{ width: '50%', cursor: 'pointer' }}
                        />
                        <span onClick={() =>closeQrSacnner()}><FontAwesomeIcon icon={faTimes} /></span>
                    </div> */}
                </Grid>
            )
        } else {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} >
                    <div style={{ display: 'none' }}>
                        <Field
                            name={fieldData.dataElement.id}
                            label={getTranslatedLabels(fieldData.dataElement)}
                            type={fieldData.dataElement.valueType}
                            component={InputFieldFF}
                            key={fieldData.dataElement.id}
                            defaultValue={defaultValue}
                        />
                    </div>
                    <p className="qrIcon" onClick={() => openQrSacnner()}><FontAwesomeIcon className="fa-3x" icon={faQrcode} /></p>
                </Grid>
            )
        }
    }, [showScannner, defaultValue, localStorage.getItem("locale")])


    return (
        <>
            {
                fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}
function ImageFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let customClassName = props.customClassName
    let dataElementGroup = props.dataElementGroup
    let customfieldobj = props.customfieldobj

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)
    const [defaultValue, setDefaultValue] = useState(null)
    console.log("fieldData.dataElement", fieldData.dataElement)

    function handleSave() {

    }

    function handleChange(files) {

        if (files.length > 0) {
            let data = new FormData();
            data.append('file', files[0]);

            axios({
                method: 'post',
                url: 'https://undp.imonitorplus.com/service/api/fileResources',
                data: data,
                headers: {
                    //'Content-Type':  'multipart/form-data',
                    Authorization: 'Basic SGVhbHRod29ya2VyQHVuZHAuY29tOkhlYWx0aHdvcmtlckAxMjM='
                }
            })
                .then(function (response) {
                    //handle success

                })
                .catch(function (response) {
                    //handle error
                })
        }


    }

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    async function openFileChooser() {
        console.log("openFileChooser")
        const file = await window.chooser.getFile({ mimeTypes: ["application/pdf", "image/*"] });
        console.log("file ", file);
        setDefaultValue(file)
    }
    useEffect(() => {

        if (validationResult != null) {
            if (values[customfieldobj.reasonForTodaysVisit] &&
                (values[customfieldobj.reasonForTodaysVisit] == "Routine Visit" ||
                    values[customfieldobj.reasonForTodaysVisit] == "Quarterly Visit" ||
                    values[customfieldobj.reasonForTodaysVisit] == "Collecting insulin")) {
                {
                    if (
                        fieldData.dataElement.id == customfieldobj.fundusPhotography)
                        validationResult.hideShow = false
                }
            }

            if (!navigator.onLine) {
                if (defaultValue) {
                    values[fieldData.dataElement.id] = [defaultValue]
                }
                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? 'hide' : 'hide'}>
                        <div style={{ display: 'none' }}>
                            <Field
                                name={fieldData.dataElement.id}
                                label={getTranslatedLabels(fieldData.dataElement)}
                                type={fieldData.dataElement.valueType}
                                component={InputFieldFF}
                                key={fieldData.dataElement.id}
                                defaultValue={defaultValue}
                                value={''}
                            />
                        </div>
                        <label className={customClassName}>{getTranslatedLabels(fieldData.dataElement)}</label>
                        <p className="qrIcon" onClick={() => openFileChooser()}><FontAwesomeIcon className="fa-3x" icon={faFileUpload} /></p>
                        {defaultValue && defaultValue.name ?
                            <p className={defaultValue && defaultValue.name ? '' : 'hide'}>{defaultValue && defaultValue.name ? defaultValue.name : ''}</p>
                            :
                            values[fieldData.dataElement.id] && values[fieldData.dataElement.id].includes('RTMUPLOADS') ?
                                <p className={values[fieldData.dataElement.id] ? '' : 'hide'}>{values[fieldData.dataElement.id] ? values[fieldData.dataElement.id].split('RTMUPLOADS/') ? values[fieldData.dataElement.id].split('RTMUPLOADS/')[1] : '' : ''}</p>
                                :
                                <p className={values[fieldData.dataElement.id] ? '' : 'hide'}>{values[fieldData.dataElement.id] ? values[fieldData.dataElement.id] : ''}</p>
                        }

                    </Grid>
                )
            } else {
                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                        {/* <DropzoneArea
                            name={fieldData.dataElement.id}
                            onChange={handleChange.bind(this)}
                            filesLimit={1}
                        /> */}

                        <Field
                            name={fieldData.dataElement.id}
                            label={getTranslatedLabels(fieldData.dataElement)}
                            component={FileInputFieldFF}
                            key={fieldData.dataElement.id}
                            required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                            value={[]}
                            accept=".pdf, image/*"
                            className={customClassName}
                        //onChange={handleChange.bind(this)}
                        //validate={composeValidators(required, URLCheck)}
                        />

                    </Grid>
                )
            }
        }

    }, [validationResult, defaultValue, localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function CreateField(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let programData = props.programData
    let dataElementGroup = props.dataElementGroup
    let stages = props.stages
    let orgid = props.orgid
    let OUM = OUMapping(values)
    let OUJSON = props.OUJSON
    let customfieldobj = props.customfieldobj;
    let programBoDetails = props.programBoDetails
    let customClassName = props.customClassName
    let Configuration = props.Configuration
    let symptomsReferralID = null;
    let currentstagename = props.currentstagename
   // console.log("currentstagename",currentstagename)
    try {
        if (dataElementGroup && dataElementGroup.length > 0) {
            let dEID = dataElementGroup.filter(
                (obj) => obj.displayName == customfieldobj.symptomsDisplayName && obj.description && obj.description == "Currently are you experiencing any of the following symptoms"
                //(obj) => obj.description && obj.description == "Currently are you experiencing any of the following symptoms"
            )
            if (
                dEID && dEID.length > 0
            ) {
                symptomsReferralID = dEID[0].id
            }
            //let dEID = dataElementGroup.find(obj => obj.description && obj.description == "Symptoms" && obj.displayName == fieldData.dataElement.displayName)

        }
    } catch (e) {

    }
    //console.log("symptomsReferralID ",symptomsReferralID,dataElementGroup,customfieldobj.symptomsDisplayName);

    let rules = {
        "programRule": props.programRules,
        "programRuleVariable": props.programRulesVariables
    }

    function checkFieldType() {
        let checkUnique = false;
        if (fieldData.dataElement.attributeValues.length > 0 && fieldData.dataElement.attributeValues[0].attribute.displayName == "unique" && fieldData.dataElement.attributeValues[0].value) {
            checkUnique = true;
        }


        switch (fieldData.dataElement.valueType) {
            case 'TEXT':
                return fieldData.dataElement.unique
                    ?
                    <DefaultValueField
                        fieldData={fieldData}
                        programRules={programRules}
                        programRulesVariables={programRulesVariables}
                        values={values}
                        dataElementGroup={dataElementGroup}
                        customClassName={customClassName}
                    />
                    :
                    checkUnique
                        ?
                        <DefaultStageValueField
                            fieldData={fieldData}
                            programRules={programRules}
                            programRulesVariables={programRulesVariables}
                            values={values}
                            dataElementGroup={dataElementGroup}
                            customClassName={customClassName}
                        />
                        :
                        fieldData.dataElement.fieldMask == "Facility Referral" ||
                            fieldData.dataElement.fieldMask == "Select HTC Referral Location"
                            ?
                            <ReferalConfig
                                fieldData={fieldData}
                                programRules={programRules}
                                programRulesVariables={programRulesVariables}
                                values={values}
                                dataElementGroup={dataElementGroup}
                                programData={programData}
                                customfieldobj={customfieldobj}
                                programBoDetails={programBoDetails}
                                symptomsFID={symptomsReferralID}
                                customClassName={customClassName}
                                Configuration={Configuration}
                            />
                            :
                            fieldData.renderType && fieldData.renderType['DESKTOP'] && fieldData.renderType['DESKTOP'].type == "QR_CODE" ?
                                <QrCodeScanner
                                    fieldData={fieldData}
                                    programRules={programRules}
                                    programRulesVariables={programRulesVariables}
                                    values={values}
                                    customClassName={customClassName}
                                />
                                : <InputFieldConfig
                                    fieldData={fieldData}
                                    programRules={programRules}
                                    programRulesVariables={programRulesVariables}
                                    values={values}
                                    dataElementGroup={dataElementGroup}
                                    OUJSON={OUJSON}
                                    programorgid={orgid}
                                    symptomsFID={symptomsReferralID}
                                    customfieldobj={customfieldobj}
                                    customClassName={customClassName}
                                    Configuration={Configuration}
                                />

            case 'IMAGE':
            case "FILE_RESOURCE":
                return <ImageFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    dataElementGroup={dataElementGroup}
                    customClassName={customClassName}
                    customfieldobj={customfieldobj}
                />

            case 'DATE':
                return <DateFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    dataElementGroup={dataElementGroup}
                    customClassName={customClassName}
                    customfieldobj={customfieldobj}
                />

            case 'AGE':
                return <AgeFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    dataElementGroup={dataElementGroup}
                    customClassName={customClassName}
                />

            case 'PHONE_NUMBER':
                return <PhoneNumberFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    dataElementGroup={dataElementGroup}
                    customClassName={customClassName}
                />

            case 'EMAIL':
                return <EmailFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    dataElementGroup={dataElementGroup}
                    customClassName={customClassName}
                />
            case 'BOOLEAN':
                //dataElementGroup
                if (
                    dataElementGroup.filter(
                        (obj) => obj.displayName == fieldData.dataElement.displayName
                    ).length > 0
                ) {
                    const filterDataElementGroup = dataElementGroup.filter(
                        (obj) => obj.displayName == fieldData.dataElement.displayName
                    )[0];

                    return (
                        <MultiSelectConfig
                            fieldData={fieldData}
                            programRules={programRules}
                            programRulesVariables={programRulesVariables}
                            values={values}
                            DataElementGroup={filterDataElementGroup}
                            dataElementGroup={dataElementGroup}
                            programObj={programData}
                            stages={stages}
                            customfieldobj={customfieldobj}
                            customClassName={customClassName}
                        />
                    )


                } else {
                    // const filterDataElementGroup = dataElementGroup.dataElementGroups.filter(obj => obj.displayName == attribute.dataElement.displayName)[0]

                    let ShowFieldFlag = true;
                    dataElementGroup.map((DEG) => {
                        DEG.dataElements.map((DataElements) => {
                            if (DataElements.id == fieldData.dataElement.id) {
                                ShowFieldFlag = false;
                            }
                        });
                    });

                    if (ShowFieldFlag) {
                        return <BooleanFieldConfig
                            fieldData={fieldData}
                            programRules={programRules}
                            programRulesVariables={programRulesVariables}
                            values={values}
                            dataElementGroup={dataElementGroup}
                            customClassName={customClassName}
                        />
                    } else {
                        return <> </>;
                    }
                }

            case "TRUE_ONLY":
                if (
                    dataElementGroup.filter(
                        (obj) => obj.displayName == fieldData.dataElement.displayName
                    ).length > 0
                ) {
                    const filterDataElementGroup = dataElementGroup.filter(
                        (obj) => obj.displayName == fieldData.dataElement.displayName
                    )[0];

                    return (
                        <MultiSelectConfig
                            fieldData={fieldData}
                            programRules={programRules}
                            programRulesVariables={programRulesVariables}
                            values={values}
                            DataElementGroup={filterDataElementGroup}
                            programObj={programData}
                            stages={stages}
                            dataElementGroup={dataElementGroup}
                            customClassName={customClassName}
                        />
                    )


                } else {
                    // const filterDataElementGroup = dataElementGroup.dataElementGroups.filter(obj => obj.displayName == attribute.dataElement.displayName)[0]

                    let ShowFieldFlag = true;
                    dataElementGroup.map((DEG) => {
                        DEG.dataElements.map((DataElements) => {
                            if (DataElements.id == fieldData.dataElement.id) {
                                ShowFieldFlag = false;
                            }
                        });
                    });

                    if (ShowFieldFlag) {
                        return <BooleanFieldConfig
                            fieldData={fieldData}
                            programRules={programRules}
                            programRulesVariables={programRulesVariables}
                            values={values}
                            dataElementGroup={dataElementGroup}
                            customClassName={customClassName}
                        />
                    } else {
                        return <> </>;
                    }
                }
            // case 'TRUE_ONLY': 
            //     return <BooleanFieldConfig
            //         fieldData={fieldData}
            //         programRules={programRules}
            //         programRulesVariables={programRulesVariables}
            //         values={values}  
            //     />
            case 'TIME':
                return <TimeFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    dataElementGroup={dataElementGroup}
                    customClassName={customClassName}
                />

            case 'DATETIME':
                return <DateTimeFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    dataElementGroup={dataElementGroup}
                    customClassName={customClassName}
                />

            case 'INTEGER':
            case 'INTEGER_POSITIVE':
            case 'INTEGER_NEGATIVE':
            case 'INTEGER_ZERO_OR_POSITIVE':
            case 'NUMBER':
                return <IntegerConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    dataElementGroup={dataElementGroup}
                    customClassName={customClassName}
                    customfieldobj={customfieldobj}
                    programData={programData}
                    currentstagename={currentstagename}
                   
                />
            case 'LONG_TEXT':
                return <TextAreaConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    dataElementGroup={dataElementGroup}
                    customClassName={customClassName}
                />

            case 'USERNAME':
                return <UserNameConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    dataElementGroup={dataElementGroup}
                    programorgid={orgid}
                    customClassName={customClassName}
                />

            case 'URL':
                return <URLConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    dataElementGroup={dataElementGroup}
                    customClassName={customClassName}
                />

            case 'ORGANISATION_UNIT':
                let optionsId = ''
                const childDropDown = JSON.parse(localStorage.getItem('childDropDown'))
                if (childDropDown != null) {
                    const fieldOptionFilter = childDropDown.filter(obj => obj.fieldId == fieldData.dataElement.id)
                    if (fieldOptionFilter.length > 0) {
                        optionsId = fieldOptionFilter[0].value
                    }

                }

                const defaultValue = values[fieldData.dataElement.id]
                let defaultOption = {}
                if (defaultValue != undefined) {
                    const meta = JSON.parse(localStorage.getItem('metaData'))
                    const LocationFilter = programData.organisationUnits.filter(OU => OU.id == values[fieldData.dataElement.id])
                    //const locationName = LocationFilter.length > 0 ? LocationFilter[0].displayName : ""
                    //const UserBOLocationFilter = userBO && userBO.organisationUnits ? userBO.organisationUnits.filter(OU => OU.id == values[fieldData.dataElement.id]) : []
                    const OUJSONLocationFilter = OUJSON && OUJSON.organisationUnits ? OUJSON.organisationUnits.filter(OU => OU.id == values[fieldData.dataElement.id]) : []
                    const locationName = LocationFilter.length > 0 ? LocationFilter[0].displayName : OUJSONLocationFilter.length > 0 ? OUJSONLocationFilter[0].displayName : ''
                    defaultOption = {
                        'id': values[fieldData.dataElement.id],
                        'label': locationName,
                        'value': values[fieldData.dataElement.id]
                    }

                    if (OUM[fieldData.dataElement.id] != undefined) {
                        if (OUM[fieldData.dataElement.id].parent != '') {
                            optionsId = values[OUM[fieldData.dataElement.id].parent]
                        }
                    }
                }
                return <HandleOUOptions
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    programData={programData}
                    options={optionsId}
                    defaultOption={defaultOption}
                    OUJSON={OUJSON}
                    customClassName={customClassName}
                //data={fieldData} values={values} rules={rules} options={optionsId} defaultOption={defaultOption}
                />

        }
    }


    return (
        <>
            {checkFieldType()}
        </>

    )
}

export default CreateField
